import React, { FC } from "react";
import { Switch as MuiSwitch } from "@mui/material";

type Props = React.ComponentProps<typeof MuiSwitch>;

const Switch: FC<Props> = (props) => {
    return <MuiSwitch {...props}/>
}

export default Switch;